/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React from 'react';

function CategoryToolTip({ hover }) {
    const Arr = [{ key: 'A', value: 10 },
        { key: 'B', value: 21 },
        { key: 'C', value: 45 }];
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
            }}
            id="tooltip-information"
            role="tooltip"
            className={`inline-block absolute ${hover ? 'visible' : 'invisible'} z-10 pt-1.5 px-2.5 pb-3 bg-white rounded-lg shadow-s2 w-[173px]`}
        >
            <p className="text-xs font-semibold text-[#555259]">Delivery Lead Time</p>
            {Arr.map((item) => (
                <div className="flex mt-2.5" key={item.key}>
                    <div className="w-1/2">
                        <div className="flex">
                            <p className="text-xs3 font-semibold text-[090406]">Category</p>
                            <p className="text-xs3 font-normal text-white px-1 bg-[#555259] rounded-[3px] w-fit ml-1.5">{item.key}</p>
                        </div>
                    </div>
                    <div className="w-1/2">
                        <p className="text-xs3 font-normal text-[#000000]">
                            {item.value}
                            {' '}
                            Days Maximum
                        </p>
                    </div>
                </div>
            ))}
            <div className="tooltip-arrow" data-popper-arrow />
        </motion.div>
    );
}
export default CategoryToolTip;
